import React, { ElementType } from 'react';

import { Box, IconProps } from '@chakra-ui/react';
import { StyledTooltip } from 'styles/common';

import { Reorder } from 'assets/assetsV1/iconComponents';

const ReorderIcon: ElementType<IconProps> = Reorder;

const AdminReorderHandle = () => (
  <StyledTooltip
    title="This agenda item cannot be reordered/edited
    since admin has requested to discuss it in your 1:1"
  >
    <Box
      w="20px"
      h="20px"
      bg="#FFFFFF"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="absolute"
      top="26px"
      left="-10px"
      className="admin-reorder-handle"
      visibility="hidden"
    >
      <ReorderIcon color="#CCCCCC" boxSize="20px" />
    </Box>
  </StyledTooltip>
);

export { AdminReorderHandle };
